import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cf23a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16.5,15c-3.59,0-6.5-2.91-6.5-6.5c0-2.283,1.18-4.288,2.96-5.447C12.645,3.019,12.325,3,12,3c-4.971,0-9,4.029-9,9 c0,4.971,4.029,9,9,9c4.537,0,8.279-3.36,8.899-7.725C19.741,14.343,18.199,15,16.5,15z" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12,7c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S14.761,7,12,7z M19.778,5.636l-1.414-1.414l-2.121,2.121l1.414,1.414 L19.778,5.636z M7.757,6.343L5.636,4.222L4.222,5.636l2.121,2.121L7.757,6.343z M4.222,18.364l1.414,1.414l2.121-2.121l-1.414-1.414 L4.222,18.364z M16.243,17.657l2.121,2.121l1.414-1.414l-2.121-2.121L16.243,17.657z M13,2h-2v3h2V2z M5,11H2v2h3V11z M11,22h2v-3 h-2V22z M19,11v2h3v-2H19z" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { useStore } from 'vuex';
import i18, { State } from '@/store/i18'
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[i18.name])
const lang = computed(() => data.value.texts[data.value.lang.list[data.value.lang.now]].topMenu)

function onSwitchDarkMode() {
    store.commit('switchDarkMode', store.state.darkMode ? 'false' : 'true')
    if (store.state.darkMode) {
        store.commit('bible-detail/setColor', 4)
    } else {
        store.commit('bible-detail/setColor', 0)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "switch",
    onClick: onSwitchDarkMode
  }, [
    _createElementVNode("div", null, [
      (_unref(store).state.darkMode)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
    ]),
    _createTextVNode(" " + _toDisplayString(_unref(store).state.darkMode ? _unref(lang).dark : _unref(lang).light), 1)
  ]))
}
}

})